import * as React from 'react';
import {Col, Row} from 'reactstrap';
import './ClientMastHeadContent.css';
import ClientPhoneNumberModal from './ClientPhoneNumberModal';

interface IClientMastHeadContent {
  userFirstName?: string;
  clientId: string;
  dateTime: string;
};

const ClientMastHeadContent: React.FunctionComponent<IClientMastHeadContent> = (props: IClientMastHeadContent) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleHelpModal = ()=>{
    setIsOpen(!isOpen);
  }
  return (
    <Row noGutters={true} className="ClientMastHeadContent">
      <Col md="2" lg="2" xl="4">
        <span className='commercialBankingText float-right paddingRight10'>GEM CONNECT HELP AND SUPPORT</span>
       
      </Col>
      <Col md="10" lg="10" xl="8">
        <Row noGutters={true}>
          <Col xs="2">
              <span className="phoneNumberButton" onClick={toggleHelpModal}>
                <span className='sideBorder float-left'/>
                <span className='phoneIcon float-left'/>
                <span className='sideBorder float-left'/>
              </span>
          </Col>
        
        </Row>
      </Col>
      <ClientPhoneNumberModal isOpen={isOpen} okayClick={toggleHelpModal}/>
    </Row>
  );
};

export default ClientMastHeadContent;


// WEBPACK FOOTER //
// ./src/components/shared/header/client/ClientMastHeadContent.tsx